import styled, { css } from "styled-components"

import ContentfulCTA from "components/Banners/ContentfulCTA"
import VideoCarousel from "components/Carousels/VideoCarousel"
import InnerWrapper from "components/InnerWrapper"
import colors from "styles/colors"
import { fmobile, fresponsive, ftablet } from "utils/fullyResponsive"
import { useEffect } from "react"

interface SecuredProps {
  activePageContent: Queries.MainPageQuery["allContentfulMainPage"]["nodes"][number]
}

export default function Secured({ activePageContent }: SecuredProps) {
  const { customCta } = activePageContent
  useEffect(()=>{
    if(window.location.hash){
      window.location.href = window.location.hash
    }
  },[])
  return (
    <Wrapper>
      <ContentfulCTA bannerData={customCta} />
      <InnerWrapper center>
        {activePageContent.videoCarousel && (
          <>
           <a id="watch-our-story"></a>
<VideoCarousel justVideo data={activePageContent.videoCarousel} />
           
          </>
        )}
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${colors.lightMode};
  will-change: transform;
  transform: translate3d(0, 0, 0, 0);
  overflow: hidden;

  ${fresponsive(css`
    padding: 0;
  `)}

  ${ftablet(css`
    padding: 0 0 150px;
  `)}

  ${fmobile(css`
    padding: 0;
  `)}
`
